export default "__VITE_ASSET__d054aZVv__"